import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

    constructor(public location: Location, private router: Router) {}

    ngOnInit() {
      window.addEventListener('storage', (event) => {
        if (event.storageArea == localStorage) {
             let token = localStorage.getItem('ELItoken');
             let modes =localStorage.getItem('ELIAvailableModes');
             if(!token && !modes) { 
                this.router.navigate(['/LOGGEDOUT']); 
             }
        }
    });


    }

    isMap(path){
      var titlee = this.location.prepareExternalUrl(this.location.path());
      titlee = titlee.slice( 1 );
      if(path == titlee){
        return false;
      }
      else {
        return true;
      }
    }
}
